/* eslint-disable no-dupe-keys */
export default {
  device_test_report: {
    name: '设备测试报告',
    // 属性（一般与对象内容匹配）
    prop: {
      device_sn: '设备编号',
      device_order: '设备订单',
      reporter: '报告员',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询设备编号'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    titles: {
      base_info: '基本信息',
      device_order: '设备订单'
    }
  }
}
